import { selectCurrentUserId, useAppSelector, useGetUserExpenseLimitsQuery } from 'mmfintech-backend-api'
import { formatMoney, tr } from 'mmfintech-commons'
import type React from 'react'
import '../SpendingLimitBar.scss'

function SpendingLimitBarUser() {
  const currentUserId = useAppSelector(selectCurrentUserId)

  const { data: expenseLimits } = useGetUserExpenseLimitsQuery(
    { merchantUserId: currentUserId },
    {
      skip: !currentUserId
    }
  )

  const { availableMonthlyVolume, monthlyVolume, currency, spentMonthlyVolume } = expenseLimits || {}

  const availableMonthlyVol = availableMonthlyVolume > 0 ? availableMonthlyVolume : 0
  const progressPercentage = monthlyVolume ? 100 - (availableMonthlyVol / monthlyVolume) * 100 : 100

  function getProgressBarColor() {
    if (!monthlyVolume) return '#53B4FB'
    if (progressPercentage <= 50) return '#73D243'
    if (progressPercentage <= 80) return '#F9BD46'
    return '#FF3131'
  }

  if (!expenseLimits) {
    return null
  }

  return (
    <div>
      <div className='progress-bar-info-wrapper'>
        <div>
          <span className='info-text'>{tr('PORTAL.COMPONENTS.LIMITS_BAR.MONEY_SPENT', 'Money spent')}:</span>
          <span>{formatMoney(spentMonthlyVolume, currency)}</span>
        </div>
        <div>
          <span className='info-text'>{tr('PORTAL.COMPONENTS.LIMITS_BAR.MONTHLY_LIMIT', 'Monthly limit')}:</span>
          {monthlyVolume ? <span>{formatMoney(monthlyVolume, currency)}</span> : <span className='infinity'>∞</span>}
        </div>
      </div>
      <div
        className='progress-bar-with-info-wrapper'
        style={
          {
            '--progress-color': getProgressBarColor(),
            '--progress-width': `${progressPercentage < 9 ? 9 : progressPercentage}%`,
            '--progress-justify': monthlyVolume ? 'flex-end' : 'flex-start'
          } as React.CSSProperties
        }
      >
        <div className='progress-bar'>
          <div>{monthlyVolume ? Math.round(progressPercentage) : 0}%</div>
        </div>
      </div>
    </div>
  )
}

export default SpendingLimitBarUser
